var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.563 15.609L16.794 10.2C16.7352 10.1523 16.701 10.0807 16.701 10.005C16.701 9.92931 16.7352 9.85766 16.794 9.81L22.781 5.021C23.303 4.603 23.267 4.221 23.199 4.021C23.131 3.821 22.918 3.5 22.25 3.5H12.75V2C12.75 1.17157 12.0784 0.5 11.25 0.5H5.25C4.97386 0.5 4.75 0.723858 4.75 1V13C4.75 13.2761 4.97386 13.5 5.25 13.5H9.48C8.7976 13.8582 8.2501 14.4286 7.92 15.125C7.79524 15.4334 7.83203 15.7837 8.01814 16.0594C8.20425 16.3352 8.51532 16.5003 8.848 16.5H23.248C23.4608 16.5006 23.6506 16.3665 23.7211 16.1657C23.7916 15.965 23.7274 15.7416 23.561 15.609H23.563Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 0C0.921573 0 0.25 0.671573 0.25 1.5V22.5C0.25 23.3284 0.921573 24 1.75 24C2.57843 24 3.25 23.3284 3.25 22.5V1.5C3.25 0.671573 2.57843 0 1.75 0Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.e9d98edf.svg";
export { ForwardRef as ReactComponent };